import { requests } from "../../../../api/agent"

export default {
	create                : (params) => requests.post('/ReZone/create', params),
	update                : (params) => requests.post('/ReZone/update', params),
	delete                : (params) => requests.getWithParams('/ReZone/delete', params),
	restore               : (params) => requests.getWithParams('/ReZone/restore', params),
	getPaged              : (params) => requests.getWithParams('/ReZone/getPaged', params),
    getPagedAll           : (params) => requests.getWithParams('/ReZone/getPagedAll', params),
	getPagedAudit         : (params) => requests.getWithParams('/ReZone/getPagedAudit', params),
	getZones 			  : (params) => requests.getWithParams('/ReZone/getList', params),
}